export default "__VITE_ASSET__6b8ce057__"